import { Injectable } from '@angular/core';
import { AuthGuardAbstractService, AuthCoreService, ConnectService, StatutService, AlertService } from 'sigale-angular';

@Injectable()
export class AuthGuardService extends AuthGuardAbstractService {

	constructor(public authService: AuthCoreService, public connectService: ConnectService, public statutService: StatutService, public alertService: AlertService) {
		super(authService, connectService, statutService, alertService);
	}
}
